import Http from 'vue-resource/src/http'
import Turbolinks from 'turbolinks'

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  actions: {
    showOverrideModal({dispatch}, {uploadNewPath, overridePath, onlyNewOne, filename, year, description}) {
      const options1 = {
        uploadNewPath,
        overridePath,
        onlyNewOne,
        filename,
        year,
        description
      }
      dispatch('dialogs/showModal', {currentProperties: options1, dialogType: 'override-confirmation-dialog'}, {root: true})
    },

    confirm({state, dispatch}, {url, description}) {
      Http.post(url, {description}).then((_) => {
        Turbolinks.reload()
      }, (response) => {
        if (response.errors) {
          window.app.notify(response.errors, {type: 'error'})
        }
      })
    },

    closeOverrideConfirmation({state, commit, rootState}) {
      rootState.showDialog = false
      rootState.dialogType = null
    },

    incrementIfOddOnRootSum({state, commit, rootState}) {
      if ((state.count + rootState.count) % 2 === 1) {
        commit('increment')
      }
    }
  },
  mutations: {
  }
}
